export default __webpack_public_path__ + "static/banner-8f47a22a24db71b94e45ede52fe6ade7.png";